/* eslint-disable */
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../Components/ui/tabs'
import { useState, useEffect } from 'react'
import MFBasketsInvestments from '../MutualFundsBaskets/MFBasketsInvestments'
import MFIndividualInvestments from './MFIndividualInvestments'
import { ChevronRight } from 'lucide-react'
import PostHogTracker from '../../utils/PostHogTracker'
import MFNonFabitsAssets from './MFNonFabitsAssets'
import { useRecoilValueLoadable } from 'recoil'
import { MutualFundsHolding } from '../../store/MFStore'

const MFInvestments = () => {
  const mfHolding = useRecoilValueLoadable(MutualFundsHolding)
  const filteredHoldings =
    mfHolding?.contents?.mainData?.filter(
      (item) => item?.isOutsideData === 1 && Number(item?.balance) > 0 && item?.isincd,
    ) || []

  const [tabValue, setTabValue] = useState('Individual Investments')
  
  useEffect(() => {
    // Track holdings page viewed
    PostHogTracker.holdingsTabClicked()
    PostHogTracker.pageViewed('My Portfolio - Holdings')
  }, [])

  return (
    <>
      <div className='max-w-[1128px] mx-auto'>
        <h2 className='py-4 px-2 lg:px-0 font-semibold text-black-500 leading-6 tracking-[-4%] flex items-center gap-x-1'>
          My Portfolio
          <ChevronRight />
        </h2>
      </div>

      <div className='max-w-[1128px] mx-auto'>
        <Tabs defaultValue='Goals' className='relative mr-auto w-full'>
          <TabsList className='w-full justify-start rounded-none border-b bg-transparent p-0'>
            <TabsTrigger
              value='Goals'
              className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
            >
              Goals
            </TabsTrigger>

            <TabsTrigger
              value='Mutual Funds'
              className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
            >
              Mutual Funds
            </TabsTrigger>

            {filteredHoldings.length > 0 && (
              <TabsTrigger
                value='Non Fabits Assets'
                className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
              >
                Non Fabits Assets
              </TabsTrigger>
            )}
          </TabsList>

          <TabsContent value='Goals'>
            <MFBasketsInvestments />
          </TabsContent>

          <TabsContent value='Mutual Funds'>
            <MFIndividualInvestments />
          </TabsContent>
          {filteredHoldings.length > 0 && (
            <TabsContent value='Non Fabits Assets'>
              <MFNonFabitsAssets />
            </TabsContent>
          )}
        </Tabs>
      </div>
    </>
  )
}

export default MFInvestments
